import { Link } from "react-router-dom";
import DownloadResume from "../about/DownloadResume";
import Resume from "../../assets/documents/Resume_NguyenPhucTien.pdf";
import DownloadIcon from "../../assets/images/download-icon.png";
import PreviewIcon from '@mui/icons-material/Preview';

const HeaderPreview = () => {
  return (
    <article className="header">
      <h1 className="header-font white-text h1-tag">
        Hi, I'm <br />
        <em className="pink-text">Tien</em>
        {/* <br />Embedded developer */}
      </h1>
      <p className="gray-text p-tag">Embedded Software Engineer</p>

      <div className="button-container">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Link
            className="pink-text"
            to="/portfolio"
            style={{ marginRight: "10px" }}
          >
            Check my work
          </Link>
          <Link
            className="pink-text download-link"
            to={Resume}
            target="_blank"
            download ="Resume_NguyenPhucTien.pdf"
            style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}
          >
            <img 
              src={DownloadIcon} 
              alt="Download icon" 
              className="download-img"
              style={{ marginLeft: "-5px" }} 
              download="Resume_NguyenPhucTien"/>
            <span style={{ marginLeft: "3px", marginRight: "10px" }}><div>Download Resume</div></span>
          </Link>
        </div>
      </div>
    </article>
  );
};

export default HeaderPreview;
